import { configureStore } from '@reduxjs/toolkit';
import user from './user'
import mcode from './mcode'
import client from './client'
import project from './project'
import projectcost from './projectcost'
import comment from './comment'
import schedule from './schedule';
import scheduledownload from './scheduledownload';
import profile from './profile';

export const store = configureStore({
    reducer: {
        user: user,
        mcode:mcode,
        client:client,
        project:project,
        projectcost:projectcost,
        schedule:schedule,
        comment:comment,
        scheduledownload:scheduledownload,
        profile:profile,
    },
});
